import { formatAddress } from "@utilities/formatAddress";
import { EventDetailProps } from "../C37.5_EventDetail";

import IconExternal from "../../../public/image/svg/external.svg";
import styles from "../C37.5_EventDetail.module.scss";

const LocationSection = (
  props: Pick<
    EventDetailProps,
    "eventLocationName" | "eventLocationGoogleMapsLink"
  >
) => {
  const { eventLocationName, eventLocationGoogleMapsLink } = props;
  return (
    <>
      {eventLocationName && <p>{formatAddress(eventLocationName)}</p>}
      {eventLocationGoogleMapsLink && (
        <>
            <IconExternal className={styles["icon-external"]} aria-hidden />
          <a
            className="directions"
            target="_blank"
            href={eventLocationGoogleMapsLink}
            rel="noreferrer"
          >
            Find us
          </a>
        </>
      )}
    </>
  );
};

export default LocationSection;
